import { useCallback, useEffect, useMemo, useState } from "react";
import { userReportsApi } from "../api";
import { getApiErrorMessage, partitionReports } from "../utils";
import type { UserReport } from "../types/reports";

export function useReportsList(userId?: string) {
  const [reports, setReports] = useState<UserReport[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const reload = useCallback(async () => {
    setError("");
    try {
      const response = await userReportsApi.list();
      setReports(Array.isArray(response.data) ? response.data : []);
    } catch (caught) {
      setError(getApiErrorMessage(caught, "Could not load reports"));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  const partitioned = useMemo(() => partitionReports(reports, userId), [reports, userId]);

  return { reports, loading, error, reload, ...partitioned };
}
